<template>
  <v-container style="position:absolute;pointer-events:none" fill-height fluid>
    <v-row no-gutters align="end" 
        style="height: 100%;padding-bottom:20px"
        v-if="isProductFocused"
        >
      <v-spacer/>
      <v-btn dark large style="pointer-events:auto" class="mr-2" @click="AddFocusedItemToCart()">
        Add to Shopping Cart
      </v-btn>
      <v-btn dark large style="pointer-events:auto" @click="SetShoppingCartVisibility(true)">
        Shopping Cart
      </v-btn>
      <v-btn dark large style="pointer-events:auto" class="ml-2" @click="SetProductFocus(false)">
        Put down
      </v-btn>
      <v-spacer/>
    </v-row>
    <v-dialog
        v-model="shoppingCartDialog"
        width="700px"
      >
          <v-card color="black" dark>
            <v-card-title
              class="headline"
              primary-title
            >
              <div>
              Shopping Cart
              </div>
              <v-spacer></v-spacer>
              <v-btn icon text @click="shoppingCartDialog = false">
                <v-icon>
                  mdi-close
                </v-icon>
              </v-btn>
            </v-card-title>
          </v-card>

          <v-card color="black"
          style="max-height:60%;overflow-y:auto"
          >
              <v-card-text>
                <v-list two-line dark >

                  <v-list-item
                    v-for="(item, index) in activeCart"
                    :key="index"
                  >
                  
                    <v-list-item-avatar size=69>
                      <v-img v-bind:src="item.thm" aspect-ratio="1.7"></v-img>
                    </v-list-item-avatar>
                    

                    <v-list-item-content class="ml-2">
                      <v-list-item-title>{{ item.upc }} </v-list-item-title>
                      <v-list-item-subtitle>{{ item.name }}</v-list-item-subtitle>
                    </v-list-item-content>

                    <v-spacer></v-spacer>

                    <v-flex >
                      <v-btn icon
                      @click="(item.quantity == 1) ? OnRemoveItemFromCart(index) : OnChangeItemQuantity(item,index,-1);"
                      >
                        <v-icon color="red">fa-minus</v-icon>
                      </v-btn>
                      <span class="title">
                        {{item.quantity}}
                      </span>
                      
                      <v-btn icon
                      @click="OnChangeItemQuantity(item,index,1);"
                      >
                        <v-icon color="red">fa-plus</v-icon>
                      </v-btn>
                    </v-flex>

                    <v-list-item-action>
                      <v-btn 
                      style="pointer-events:auto"
                      @click="OnRemoveItemFromCart(index)"
                      icon 
                      ripple>
                        <v-icon color="red">fa-trash-alt</v-icon>
                      </v-btn>
                    </v-list-item-action>
                  </v-list-item>
      
                </v-list>
                </v-card-text>

          
          </v-card>
          <v-card color="black" dark>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="green"
                :disabled="!allowCheckoutButton"
                @click="Checkout()"
              >
                Checkout
              </v-btn>
              <v-btn
                color="red"
                dark
                @click="OnClearCart()"
              >
                Clear Cart
              </v-btn>
            </v-card-actions>
          </v-card>
      </v-dialog>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import { mapState } from 'vuex'
import { mapMutations } from 'vuex'
export default {
  name: 'ShoppingCart',
  components: {
  },
  props: {
    isActive : false,
    showProductOptions : false,
    allowCheckoutButton : true
  },
  computed: {
    ...mapGetters("sessionState", [
        "GetBabPnl",
        "GetCurrentStageData"
    ]),
    ...mapState("sessionState", [
      "isProductFocused",
      "showShoppingCart",
      "focusedProductData"
    ]),
    ...mapState("commercialState", [
      "activeCart"
    ]),
  },

  mounted: () => {

  },
  data: () => ({

      initalized : false,
      shoppingCartDialog : false,
  }),
  methods: {

     ...mapMutations("sessionState", [
      "SetShoppingCartVisibility",
      "SetProductFocus"
    ]),

    ...mapMutations("commercialState", [
      "AddItemToCart",
      "RemoveItemFromCart",
      "AdjustQuantityForItem",
      "ClearCart"
    ]),

    ...mapMutations("trackedState", [
      "AddTrackedEvent"
    ]),

    OnPutDownProduct()
    {
      this.AddTrackedEvent({
        type : "PRODUCTPUTDOWN",
        key :  this.focusedProductData.idf
      });
    },
    AddFocusedItemToCart()
    {
      for (let i = 0; i < this.activeCart.length; i++) {
        const element = this.activeCart[i];
        if(element.upc == this.focusedProductData.idf)
        {
          this.AdjustQuantityForItem({itemIndex : i, quantity : element.quantity + 1});
          this.SetShoppingCartVisibility(false);
          this.SetProductFocus(false);
          return;
        }
      }

      this.AddTrackedEvent({

        type : "PRODUCTADDTOCART",
        key :  this.focusedProductData.idf
      });

      this.AddItemToCart({

        name : this.focusedProductData.metaData.name,
        glbUrl : this.focusedProductData.glbUrl,
        thm : this.focusedProductData.thmUrl,
        upc : this.focusedProductData.idf,
        quantity : 1
      });

      this.SetShoppingCartVisibility(false);
      this.SetProductFocus(false);
    },
    OnChangeItemQuantity(item, index,quantity)
    {
      this.AdjustQuantityForItem({itemIndex : index, quantity : item.quantity + quantity });
    },
    OnRemoveItemFromCart(index)
    { 
      this.AddTrackedEvent({

        type : "PRODUCTREMOVEFROMCART",
        key :  this.activeCart[index].upc
      });

      this.RemoveItemFromCart(index);
    },
    OnClearCart()
    {
      this.ClearCart();
    },
    Checkout()
    {
      
    }
  },
  watch: {

      isActive : {
        handler(newVal)
        {
          
            
        }
      }, 
      shoppingCartDialog : {
        handler(newVal)
        {
          if(newVal != this.showShoppingCart)
          {
            this.SetShoppingCartVisibility(newVal);
          }
        }
      },
      showShoppingCart : {
        handler (newVal)
        {
          this.shoppingCartDialog = newVal;
        }
      }
  }
}
</script>
